export default "__VITE_ASSET__9FDo3vwi__"